/**
 * api/periods.ts —— 周期（§五 5.2）
 *
 * ⚠ context.current 【可以是 null】，那是正常业务态不是异常（红线 3.5）。
 *   一期 CUR_NO 写死为 3，完全没有空当期的概念，照搬一期写法必然在这里崩。
 * ⚠ no 与 due 都由服务端生成，前端【不许传】，也不许自己从 end 推 due。
 */
import { del, get, post, put, type ReqOptions } from './client.js';
import type {
  Period,
  PeriodAdminView,
  PeriodContext,
  PeriodCreateInput,
  PeriodUpdateInput,
} from '@shared-types';

/** 全部周期，按 no 倒序。⚠ 「临近再建」策略下这个列表很短（已结束的期 + 至多一期进行中） */
export const listPeriods = () => get<Period[]>('/api/periods');

/** 全站空态的唯一数据来源。六处空态见 types/period.ts */
export const periodContext = () => get<PeriodContext>('/api/periods/context');

/* ---------------- 管理后台 · 周期（W2-2） ---------------- */

/**
 * 管理后台周期 Tab 的整页数据（§五 5.2 补充 B1，管理员专用）。
 * ⚠ 状态、提交率、逾期支数、能不能编辑 / 删除、新建默认区间，**全部由服务端算好下发**，
 *   前端一个都不许自己推（红线 4 / 前端纪律 2）。
 */
export const adminView = (opts?: ReqOptions) => get<PeriodAdminView>('/api/periods/admin', opts);

/** 新建。⚠ 只传起止日期：no / name / due 都由服务端生成，传了会被明确拒绝 */
export const createPeriod = (input: PeriodCreateInput) => post<Period>('/api/periods', input);

/** 编辑起止日期。⚠ 已结束的期服务端会拒（CONFLICT），前端也不给按钮 */
export const updatePeriod = (id: string, input: PeriodUpdateInput) =>
  put<Period>(`/api/periods/${id}`, input);

/** 删除。⚠ 仅「最后一期且未开始」，否则服务端返回 CONFLICT */
export const deletePeriod = (id: string) => del<{ ok: true }>(`/api/periods/${id}`);
